var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"headline",attrs:{"href":_vm.link,"target":"_blank"}},[_c('span',{staticClass:"theLink pb-1"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }